import { useQuery } from '@tanstack/react-query';
import { AdminAPI } from '@shared/types/api';
import { api } from '@/lib/api';
import type { PaymentOriginFilter } from './useAdminPayments';

export type PaymentChartGranularity = 'day' | 'week' | 'month';

interface UseAdminPaymentChartsParams {
  timeframe?: string;
  origin?: PaymentOriginFilter;
  granularity?: PaymentChartGranularity;
}

export function useAdminPaymentCharts(params: UseAdminPaymentChartsParams = {}) {
  const { timeframe = 'all', origin = 'all', granularity = 'day' } = params;

  return useQuery<AdminAPI.GetPaymentChartsResponse, Error>({
    queryKey: ['admin', 'payments', 'charts', timeframe, origin, granularity],
    queryFn: async (): Promise<AdminAPI.GetPaymentChartsResponse> => {
      const searchParams = new URLSearchParams({ timeframe, granularity });
      if (origin !== 'all') searchParams.set('origin', origin);
      return api.get(`/admin/payments/charts?${searchParams.toString()}`);
    },
  });
}
